import common from './common'
const filters = {
    getExperience(value){
        if(common.isEmpty(value)){
            return "";
        }
        switch (value){
            case 0:
                return '不限';
            case 1:
                return "一年以下";
            case 2:
                return "1-3年";
            case 3:
                return "3-5年";
            case 4:
                return "5-10年";
            case 5:
                return "10年以上";
            default:
                return '不限'
        }
    },
    getNatureText: function (value){
        let natureArr = [
            "其他",
            "外商独资",
            "中外合资",
            "民营企业",
            "国有企业",
            "国内上市企业",
            "政府机关/非营利机构",
            "事业单位",
        ]
        let code = -1;
        if(typeof value =='string'){
            try {
                code = parseInt(value)
            }
            catch (e) {
                console.log(e)
            }
        }
        else if(typeof value == 'number'){
            code = parseInt(value);
        }
        else{
            return "";
        }

        return natureArr[code];
    },
    getEnterpriseScale(value){
        if(common.isEmpty(value)){
            return "";
        }
        switch (value){
            case 1:
                return "0-20人";
            case 2:
                return "20-50人";
            case 3:
                return "50-100人";
            case 4:
                return "100-500人";
            case 5:
                return "500人以上";
            default:
                return ''
        }
    },
    getDate: function(value) {
        if(common.isEmpty(value)){
            return "";
        }

        if(value == -999999999999){
            return "至今";
        }

        return common.formatDate(value,"yyyy.MM.dd hh:mm");
    },
    getDate1: function(value) {
        if(common.isEmpty(value)){
            return "";
        }

        if(value == -999999999999){
            return "至今";
        }

        return common.formatDate(value,"yyyy.MM.dd");
    },

}
export default filters;
